module.exports = __webpack_public_path__ + "static/media/chat-logo-techgpt-small.cad55ceb.svg";